module.exports = __webpack_public_path__ + "static/media/ms-mobile-logo.aad1b4a1.svg";